// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2623":"4e495f85","5904":"70b0442e","8915":"e80da2aa"}[chunkId] + ".chunk.css";
};